import { get, postFormData, serviceRoutes } from "./index";

export const consultarComentariosPorSolicitud = async ({ nmId }) => await get(serviceRoutes.consultarComentariosPorSolicitud, `?id=${nmId}`);

export const guardarNuevoComentario = async (body) => await postFormData(serviceRoutes.guardarNuevoComentario, body);
